import React from 'react'
import { Form, ModalBody,Button,Col,Label,FormGroup,Table,Row, ListGroup, ListGroupItem} from 'reactstrap';
import { SearchAsync } from '../../components/elements/SearchAsync';
import Select from 'react-select';


export const FormIndicationExamMicrobiology = (props) => {

    const {

    loading,listIndication,CreateOrUpdateExamIndications,handleSelectValuesIndication,dataIndication, listIndicationLab, CreateOrUpdateExamLabIndications,
    handleSelectValuesIndication2, dataIndicationLab

    }= props;



    return (
        <Form className="theme-form" role="form" onSubmit={CreateOrUpdateExamIndications} >
                        {/* <Col sm="12 p-1">
                            <FormGroup className="col-md-12">
                            <Select
                            isMulti
                            name="listIndication"
                            value={listIndication}
                            onChange={(e) => handleSelectValuesIndication(e, "listIndication")}
                            options={dataIndication}
                            className="basic-multi-select form-control form-control-plaintext"
                            classNamePrefix="select"
                            placeholder="Selecciona una o varias opciones"
                            noOptionsMessage={() => "Sin opciones"}
                            isSearchable={true}
                            styles={
                                {
                                    placeholder: () => ({
                                        color: "#b6bdc4"
                                    })
                                }
                            }
                        />
                        </FormGroup>
                        </Col>  <br /> <br /> <br /> <br /> 
                        <Col sm="12" className={ listIndication.length === 0 ? "d-none" : "p-l-0"}>
                            <Row>
                                <Col sm="1" className='p-r-0 p-l-0'>
                                </Col>
                                <Col sm="10" className='p-l-0'>
                                <Label className="col-12">Listado de Indicaciones</Label>
                                {
                                    listIndication.length >=1 && listIndication.map((obj,index) => {
                                        return(
                                            <div key={index} className="align-items-center row pb-2 pt-2 border-top border-right border-left border-bottom">
                                            <Col sm="12">
                                            <label className="f-14 text-secondary"><i className="icofont icofont-prescription f-22 "></i>{obj.label}</label>
                                            </Col>
                                        </div>
                                        )
                                    })
                                } 
                                </Col>
                                <Col sm="1">
                                </Col>
                            </Row>
                        </Col> */}
            <Col sm="12">
                <Row>
                    <Col sm="12">
                    <h6 className='txt-danger f-w-500'>Agregar las indicaciones en sus respectivas listas</h6>
                    </Col>
                    <Col sm="6">
                    <Col sm="12" className='mb-2 p-l-0'>
                        <FormGroup>
                        <Select
                            isMulti
                            name="listIndication"
                            value={listIndication}
                            onChange={(e) => handleSelectValuesIndication(e, "listIndication")}
                            options={dataIndication}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Selecciona una o varias opciones"
                            noOptionsMessage={() => "Sin opciones"}
                            isSearchable={true}
                            menuPortalTarget={document.body}
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    fontSize: '11px',
                                    minHeight: '38px'
                                }),
                                valueContainer: (provided) => ({
                                    ...provided,
                                    padding: '2px 8px',
                                }),
                                option: (provided) => ({
                                    ...provided,
                                    fontSize: '11px', 
                                }),
                                placeholder: (provided) => ({
                                    ...provided,
                                    color: "#b6bdc4",
                                    fontSize: '11px', 
                                }),
                                singleValue: (provided) => ({
                                    ...provided,
                                    fontSize: '11px',
                                }),
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999999,
                                }),
                            }}
                        />
                        </FormGroup> 
                    </Col> 
                    {/* <br /> */}
                    <Col sm="12" className='mt-4 p-l-0'>
                        <b className='txt-warning'>Indicaciones para pacientes</b>
                        <ListGroup className='mt-2'>
                            {
                                listIndication.length > 0 ? (
                                    listIndication.map((_find, _key) => (
                                        <ListGroupItem key={_key} className="d-flex justify-content-between align-items-center list-group-item-action">
                                            <label className='f-w-600 mb-0' style={{fontSize:"10px"}}>{_find?.label ?? "----"}</label>
                                            <i className="fa fa-check text-success"></i>
                                        </ListGroupItem>
                                    ))
                                ) : (
                                    <ListGroupItem className="d-flex justify-content-center align-items-center">
                                        <i className='fa fa-warning text-danger' ></i>
                                        <label className='f-w-600 txt-danger mb-0 ml-2' style={{fontSize:"11px"}}>No se a asigando indicaciones en esta prueba</label> 
                                    </ListGroupItem>
                                )
                            }
                        </ListGroup>
                    </Col>
                    </Col>
                    <Col sm="6">
                    <Col sm="12" className='mb-2 p-l-0'>
                        <FormGroup>
                        <Select
                            isMulti
                            name="listIndicationLab"
                            value={listIndicationLab}
                            onChange={(e) => handleSelectValuesIndication2(e, "listIndicationLab")}
                            options={dataIndicationLab}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Selecciona una o varias opciones"
                            noOptionsMessage={() => "Sin opciones"}
                            isSearchable={true}
                            menuPortalTarget={document.body}
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    fontSize: '11px',
                                    minHeight: '38px'
                                }),
                                valueContainer: (provided) => ({
                                    ...provided,
                                    padding: '2px 8px',
                                }),
                                option: (provided) => ({
                                    ...provided,
                                    fontSize: '11px', 
                                }),
                                placeholder: (provided) => ({
                                    ...provided,
                                    color: "#b6bdc4",
                                    fontSize: '11px', 
                                }),
                                singleValue: (provided) => ({
                                    ...provided,
                                    fontSize: '11px',
                                }),
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999999,
                                }),
                            }}
                        />
                        </FormGroup> 
                    </Col>
                    <br />
                    <Col sm="12" className='mt-2 p-l-0'>
                        <b className='txt-success'>Indicaciones para laboratorio</b>
                        <ListGroup>
                            {
                                listIndicationLab.length > 0 ? (
                                    listIndicationLab.map((_find, _key) => (
                                        <ListGroupItem key={_key} className="d-flex justify-content-between align-items-center list-group-item-action">
                                            <label className='f-w-600 mb-0' style={{fontSize:"10px"}}>{_find?.label ?? "----"}</label>
                                            <i className="fa fa-check text-success"></i>
                                        </ListGroupItem>
                                    ))
                                ) : (
                                    <ListGroupItem className="d-flex justify-content-center align-items-center">
                                        <i className='fa fa-warning text-danger' ></i>
                                        <label className='f-w-600 txt-danger mb-0 ml-2' style={{fontSize:"11px"}}>No se a asigando indicaciones en esta prueba</label>     
                                    </ListGroupItem>
                                )
                            }
                        </ListGroup>
                    </Col>
                    </Col>
                </Row>
            </Col>
            <ModalBody  style={{"text-align": "-webkit-right"}}>
                <Button
                        outline
                        color="primary"
                        type="submit"
                        className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                >
                    {"Guardar"}
                </Button> &nbsp;
            </ModalBody>
        </Form>
            
    )
}
